"use strict";

exports.__esModule = true;
exports["default"] = SocialTwitterInverted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialTwitterInverted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M400.7 181.3v8.8c0 89.8-68.3 193.4-193.4 193.4-38.4 0-74.4-8.4-104.4-27.6 5.4.8 10.7 1.2 16.1 1.2 31.9 0 61.4-13.8 84.4-32.2-29.5-.4-54.9-20.3-63.3-47.2 4.2.8 8.4 1.1 12.7 1.1 6.1 0 12.3-.8 18-2.3-31.1-6.1-54.5-33.8-54.5-66.8v-.8c9.2 5 19.6 8.1 30.7 8.4-18.4-12.3-30.3-33-30.3-56.4 0-12.7 3.5-23 9.2-33 33.8 41.1 83.6 66.8 140 69.8-1.1-5-1.5-10.4-1.5-15.7 0-37.6 30.3-67.9 67.9-67.9 19.6 0 37.2 8.4 49.9 21.5 15.3-3.1 29.9-8.8 43-16.5-5 15.7-15.7 29.2-29.9 37.6 13.8-1.5 26.9-5.4 39.1-10.7-9.1 13.8-20.6 25.7-33.7 35.3z",
    fill: "#939496"
  }));
}